import { render, staticRenderFns } from "./UpFile.vue?vue&type=template&id=8cbe9102&"
import script from "./UpFile.vue?vue&type=script&lang=js&"
export * from "./UpFile.vue?vue&type=script&lang=js&"
import style0 from "./UpFile.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports